import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const BranchingModelLoadable = Loadable({
  loading: LoadingPage,
  loader: () =>
    import(/* webpackChunkName: "branching-model" */ './branching-model'),
});
